import { createSlice, createSelector } from '@reduxjs/toolkit';

const initialState = {
  statusShowMissingCard: 'idle',
};

export const creditCardSlice = createSlice({
  name: 'creditCard',
  initialState,
  reducers: {
    changedStatusShowMissingCard: (state, action) => {
      state.statusShowMissingCard = action.payload.status;
    },
  },
});

export const { changedStatusShowMissingCard } = creditCardSlice.actions;

export const selectCreditCard = (state) => state?.creditCard;

export const selectWarningMissingCard = () =>
  createSelector(selectCreditCard, (state) => state.statusShowMissingCard);

export default creditCardSlice.reducer;
